module.exports = __webpack_public_path__ + "static/the-monk-and-the-riddle-bfeb101340ef308b333e968b72bee49e.jpg";